module.exports = __webpack_public_path__ + "img/PSurykantLogo.9fa944e6.png";